import { createAsyncThunk } from "@reduxjs/toolkit";
import { tryItOnService } from "./tryItOn.service";

export const processTryItOn = createAsyncThunk(
  "tryItOn/process",
  async (
    { humanImage, clotheImage }: { humanImage: File; clotheImage: string },
    { rejectWithValue }
  ) => {
    try {
      const resultImage = await tryItOnService.processImages(
        humanImage,
        clotheImage
      );
      return resultImage;
    } catch (error) {
      if (error instanceof Error) {
        if (error.message.includes("Failed to fetch")) {
          return rejectWithValue(
            "Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin."
          );
        }
        return rejectWithValue(error.message);
      }
      return rejectWithValue("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  }
);
